import { createAsyncThunk } from "@reduxjs/toolkit";
import request from "../../../../../../../service";
import {
    IEntityWithIDTranslations,
    IEntityWithTranslations,
    IErrorResponse,
    IRootState,
} from "../../../../../../../types";
import {
    deletedAdmission,
    deletedRestoreAdmission,
    setAdmissionData,
    setAdmissionRestoreData,
    updateAdmission,
} from "../store/admissionBasisSlice";

const GetAdmission = createAsyncThunk("get/admission", async (_, { dispatch, rejectWithValue, getState }) => {
    try {
        const response = await request.get("/student-admission");
        const lang = getState() as IRootState;
        const defaultLanguage = lang.languages.defaultLanguage;
        dispatch(setAdmissionData({ data: response.data, defaultLanguage }));
        return response.data;
    } catch (error) {
        const typedError = error as IErrorResponse;
        return rejectWithValue(typedError.response.data.message || "unexpected_fail");
    }
});

const SetAdmission = createAsyncThunk("set/admission", async (data: IEntityWithTranslations, { rejectWithValue }) => {
    try {
        return await request.post("/student-admission", data);
    } catch (error) {
        const typedError = error as IErrorResponse;
        return rejectWithValue(typedError.response.data.message || "unexpected_fail");
    }
});

const DeleteAdmission = createAsyncThunk("delete/admission", async (id: number, { dispatch, rejectWithValue }) => {
    try {
        const response = await request.delete(`/student-admission/${id}`);

        dispatch(deletedAdmission(id));
        return response.data;
    } catch (error) {
        const typedError = error as IErrorResponse;
        return rejectWithValue(typedError.response.data.message || "unexpected_fail");
    }
});

const EditAdmission = createAsyncThunk(
    "edit/location",
    async (data: IEntityWithIDTranslations, { dispatch, rejectWithValue }) => {
        try {
            const response = await request.put(`/student-admission/${data.id}`, data);
            dispatch(updateAdmission(response.data));
            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);

const GetDeleteAdmission = createAsyncThunk("get/delete/admission", async (_, { dispatch, rejectWithValue }) => {
    try {
        const response = await request.get(`/student-admission/deleted-items`);
        dispatch(setAdmissionRestoreData(response.data));
        return response.data;
    } catch (error) {
        const typedError = error as IErrorResponse;
        return rejectWithValue(typedError.response.data.message || "unexpected_fail");
    }
});

const RestoreDeleteAdmission = createAsyncThunk(
    "restore/delete/admission",
    async (id: number, { dispatch, rejectWithValue }) => {
        try {
            const response = await request.post(`/student-admission/restore/${id}`);
            dispatch(deletedRestoreAdmission(id));
            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);

export { GetAdmission, SetAdmission, DeleteAdmission, EditAdmission, GetDeleteAdmission, RestoreDeleteAdmission };
